<template>
    <div class="page bg-blue relative desktop-footer">
        <div class="bg-head-coin sm:block"></div>
        <div class="page-content sm:px-8 min-h-screen flex flex-col pb-5">
            <TopBar title="Home" :isShowOnlyLogo="true" :modalController="modalController"></TopBar>
            <MenuDesktop activeMenu="home"></MenuDesktop>
            <div class="sm:bg-white sm:px-5 sm:py-6 mt-4 rounded-25 flex flex-col flex-1">
                <div class="bg-white rounded-25 p-10 mx-3 h-full flex-1">

                    <div class="text-24 text-tc-blue-2 text-center">{{lbl.otp.headline}}</div>
                    <div class="my-3 text-20 text-tc-gray-3 text-center">{{lbl.otp.contact_number_lbl}}</div>
                    <div class="mb-3 text-34 text-tc-blue-2 text-center">{{displayContantNumber}}</div>

                    <div class="mb-4 text-20 text-tc-gray-3 text-center">{{lbl.otp.refcode_lbl}}{{refcode}}</div>

                    <OtpInput
                        class="mb-5"
                        ref="otp_input"
                        v-model:inputValid="isOtpValid"
                        v-model:inputOtp="otp" />

                    <div class="mb-4 font-main-medium text-20 text-tc-orange-1 text-center"
                        v-if="isError" v-html="errorMsg">
                    </div>

                    <div class="text-center">
                        <div
                            class="mb-4 text-tc-gray-1 text-20 mx-auto">
                            {{lbl.otp.timeleft}} <span class="text-tc-orange-1">{{timeLeft}}</span>
                        </div>
                        <div v-if="isOtpExpire" @click="resendOtp()"
                            class="mb-4 ml-auto mr-2 font-main-medium text-20 text-1c3e95 text-center underline">
                            {{lbl.otp.resend_otp}}
                        </div>

                    </div>

                    <div class="grid gap-3">
                        <div class="w-250px text-20 mx-auto">
                            <BlueBtn @onClick="clickVerifyOtp()" :isBtnDisabled="!isValid">{{lbl.otp.confirm}}</BlueBtn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
    </div>
</template>
<script>

// helper
import Util from '@/helper/Utility.js';
import TimerHelper from "@/helper/TimerHelper.js";
import CacheHelper from '@/helper/CacheHelper.js';
import ConfigManager from "@/config/ConfigManager.js";
//component
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import OtpInput from "@/components/Authen/Otp/OtpInput.vue";
import BlueBtn from "@/components/Button/BlueBtn.vue"
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';

// import CountDownTimer from '@/components/Utility/CountDownTimer.vue';
// mixin
import LocaleMixin from "@/mixin/LocaleMixin";
//service
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";

export default {
    name: 'verifyotp',
    mixins: [LocaleMixin],
    components: {
        TopBar,
        MenuDesktop,
        OtpInput,
        BlueBtn,
        BottomBar
        // CountDownTimer,
    },
    props: {
        dataVerify: { type: Object, required: true },
        modalController: { type: Object, required: true }
    },
    data: function () {
        return {
            isOtpExpire: false,
            refcode: '',

            timeHelper: new TimerHelper(),
            timeLeft: '',
            expireIn: 0,
            isError: false,
            isOtpValid: false,
            otp: '',
            errorMsg: ''
        }
    },
    computed: {
        displayContantNumber: function () {
            // return Util.contactNumberFormat(this.OtpProvider.state.contact_number, '-');
            return Util.contactNumberFormat(this.dataVerify.mobile, '-');
            // return Util.contactNumberFormat("0838019751", '-');
        },
        isValid: function () {
            return this.isOtpValid && !this.isOtpExpire;
        }
    },
    mounted: function () {
        // debugger
        this.initialOtp();
    },
    methods: {

        initialOtp: async function () {

            this.modalController.loadingModal.show();
            var success = await this.callApiOtp();

            if (success) {
                this.modalController.loadingModal.hide();
                // this.expireIn = 5;
                this.timeHelper.initialTimer(this.expireIn, ':', false, false);
                this.timeHelper.runTimer((timeLeft) => {
                    this.timeLeft = timeLeft;
                }, () => {
                    this.setTimeout();
                });
                // document.body.classList.add('not-scroll'); // ไม่สามารถ scroll ได้ /verifypage (vefifyOTP)
                this.open = true;
            }
        },
        callApiOtp: function () {
            this.modalController.loadingModal.show();
            return new Promise((resolve) => {
            // this.dataVerify.mobile
                BzbsOtp.requestOtp(this.dataVerify.mobile, null,)
                    .subscribe({
                        next: (res) => {

                            this.refcode = res.data.RefCode;
                            // this.refcode = res.refcode
                            this.register_state = "verifyOTP";
                            this.modalController.loadingModal.hide();
                            resolve(res);
                        },
                        error: (err) => {
                            this.errorApi(err);
                            this.modalController.loadingModal.hide();
                            resolve(null);
                        }
                    });
            });
        },
        //#region resend otp
        resendOtp: function() {
            this.isOtpExpire = false;
            this.refcode = '';
            this.otp = '';
            this.isError = false;
            this.errorMsg = '';

            this.$refs['otp_input'].resetOtp();

            this.onResendOtp();

        },
        onResendOtp: async function () {
            this.modalController.loadingModal.show();

            await this.callApiOtp();

            this.modalController.loadingModal.hide();
            this.timeHelper.runTimer((timeLeft) => {
                this.timeLeft = timeLeft;
            }, () => {
                this.setTimeout();
            });
        },
        //#endregion resend otp
        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isOtpExpire = true;
        },
        clickVerifyOtp: async function () {
            console.log(this.isValid);
            if (!this.isValid) {
                return
            }
            var success = await this.CallApiVerifyOtp();
            if (success) {
                let newDataVerify = this.dataVerify;
                newDataVerify.otp = this.otp;
                newDataVerify.refcode = this.refcode;

                this.$emit('callApiVerifyMember', this.dataVerify);
            }
        },
        CallApiVerifyOtp: function () {

            this.modalController.loadingModal.show();

            return new Promise((resolve) => {
                BzbsOtp.validateOtp(this.dataVerify.mobile, this.refcode, this.otp, "register")
                    .subscribe({
                        next: (res) => {
                            console.log(res)
                            this.setCahceRegister();
                            this.modalController.loadingModal.hide();
                            resolve(res);
                        },
                        error: (err) => {
                            console.log(err)
                            this.isError = true;
                            this.handleError(err);
                            this.modalController.loadingModal.hide();
                            resolve(null);
                        }
                });
            });
        },
        handleError: function (err) {
            if (err.id == 2091) {
                this.errorMsg = this.lbl.otp.otp_incorrect + '<br>' + 'Error Code ' + this.refcode;
            }
        },
        setCahceRegister: function () {

            var registerData = {
                mobile: this.dataVerify.mobile,
                idCard: this.dataVerify.idCard,
                nationality: this.dataVerify.nationality,
                passport: this.dataVerify.passport,
                otp: this.otp,
                refcode: this.refcode,
            }
            var cacheHelper = new CacheHelper(ConfigManager.getCacheType());
            cacheHelper.setCache('registerData', registerData);

            // var test = cacheHelper.getCache('registerData');
            // console.log(test);
        }

    }

}
</script>
